/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SecuredAllocationType = {
    PAYDAY_BOND: 'payday_bond'
} as const;
export type SecuredAllocationType = typeof SecuredAllocationType[keyof typeof SecuredAllocationType];


export function instanceOfSecuredAllocationType(value: any): boolean {
    for (const key in SecuredAllocationType) {
        if (Object.prototype.hasOwnProperty.call(SecuredAllocationType, key)) {
            if (SecuredAllocationType[key as keyof typeof SecuredAllocationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SecuredAllocationTypeFromJSON(json: any): SecuredAllocationType {
    return SecuredAllocationTypeFromJSONTyped(json, false);
}

export function SecuredAllocationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecuredAllocationType {
    return json as SecuredAllocationType;
}

export function SecuredAllocationTypeToJSON(value?: SecuredAllocationType | null): any {
    return value as any;
}

export function SecuredAllocationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SecuredAllocationType {
    return value as SecuredAllocationType;
}

